import {ChangeDetectionStrategy, Component} from '@angular/core';
import {HeaderComponent} from "../../core/components/header/header.component";
import {I18NextPipe} from "@kokos-i18next";
import {
    PostfachEingeschraenktComponent
} from "../../core/components/postfach-eingeschraenkt/postfach-eingeschraenkt.component";
import {PagesEnum} from "../../core/model/pages.enum";

@Component({
  selector: 'kokos-kein-online-zugriff',
    imports: [
        HeaderComponent,
        I18NextPipe,
        PostfachEingeschraenktComponent
    ],
  templateUrl: './kein-online-zugriff.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class KeinOnlineZugriffComponent{

    protected readonly PagesEnum = PagesEnum;
}
